import React, { useState, useEffect } from "react";
import { getFirestore, doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { Form, Button, Card } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const UserProfile = () => {
  const db = getFirestore();
  const auth = getAuth();
  const page = useLocation(); // Hook to detect location changes

  // State variables
  const [displayName, setUsername] = useState("");
  const [location, setLocation] = useState("Earth");
  const [messageSent, setMessagesSent] = useState(0);
  const [messageAmplified, setMessagesAmplified] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const user = auth.currentUser;

  // Fetch user data from Firestore
  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        const userId = user.uid;
        const userDocRef = doc(db, "earthusers", userId);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const data = userDoc.data();
          setUsername(data.displayName || user.displayName || "Anonymous");
          setLocation(data.location || "Earth");
          setMessagesSent(data.messageSent || 0);
          setMessagesAmplified(data.messageAmplified || 0);
        } else {
          // Set default values if user does not exist in Firestore
          const defaultData = {
            displayName: user.displayName || "Anonymous",
            location: "Earth",
            messagesSent: 0,
            messagesAmplified: 0,
          };
          await setDoc(userDocRef, defaultData);
          setUsername(defaultData.displayName);
          setLocation(defaultData.location);
        }
      }
    };

    fetchUserData();
  }, [user, db, auth]);

  // Save changes to Firestore
  const saveChanges = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "earthusers", userId);
      await updateDoc(userDocRef, {
        displayName,
        location,
      });
      setIsEditing(false);
    }
  };

  return (
    <div className="container mt-5">
      <h3 className="text-center mb-4">Your Profile</h3>
      <Card className="shadow-sm mx-auto" style={{ maxWidth: "500px" }}>
        <Card.Body>
          {isEditing ? (
            <>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Username</Form.Label>
                  <Form.Control
                    type="text"
                    value={displayName}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Enter your username"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Location</Form.Label>
                  <Form.Control
                    type="text"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    placeholder="Enter your location"
                  />
                </Form.Group>
              </Form>
              <div className="d-flex justify-content-between">
                <Button variant="success" style={{backgroundColor:'#2196F3', borderColor:'#2196F3' }} className="w-50 me-2" onClick={saveChanges}>
                  Save Changes
                </Button>
                <Button variant="light" className="w-50" onClick={() => setIsEditing(false)}>
                  Cancel
                </Button>
              </div>
            </>
          ) : (
            <>
              <p className="fw-bold">Username:</p>
              <p className="text-muted mb-3">{displayName}</p>

              <p className="fw-bold">Location (City, Country):</p>
              <p className="text-muted mb-3">{location}</p>

              <p className="fw-bold">Messages Sent:</p>
              <p className="text-muted mb-3">{messageSent}</p>

              <p className="fw-bold">Messages Amplified:</p>
              <p className="text-muted mb-4">{messageAmplified}</p>

              <Button variant="light" className="w-100" onClick={() => setIsEditing(true)}>
                Edit Profile
              </Button>
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default UserProfile;
